module.exports = __webpack_public_path__ + "images/logo_price_digest.b33e10680e7e65613ce9316adb1e9b6c.svg";